import React, { ReactNode, useState, FC } from 'react';
import styled from '@emotion/styled';
import ToggleIcon from '../icons/ToggleIcon';

const Heading = styled.h2`
  font-size: 1.25rem;
  line-height: 1.25rem;
  font-weight: 400;
  margin: 0;
  margin-left: 1rem;
  user-select: none;
  flex: 1;
`;

const CollapsiblePanelWrapper = styled.div<{ expanded: number }>`
  background-color: #ffffff;
  margin-bottom: 2rem;
  box-shadow: 0 0 1px 1px rgba(173, 173, 173, 0.2);
  transition: max-height 150ms ease-in-out;
  max-height: ${p => (p.expanded ? '100vh' : '58px')};
  overflow-y: hidden;
`;
const CollapsiblePanelHeader = styled.div`
  color: #0076ce;
  height: 58px;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  border-bottom: 2px solid #f5f6fb;
`;
const CollapsiblePanelBody = styled.div``;
const AnimatedToggleIcon = styled(ToggleIcon)<{ expanded: number }>`
  margin-right: 1rem;
  transition: transform 300ms ease;
  transform: ${p => (p.expanded ? 'rotate(0deg)' : 'rotate(180deg)')};
`;

interface Props {
  title: string | ReactNode;
  expanded?: boolean;
  disabled?: boolean;
}

export const CollapsiblePanel: FC<Props> = props => {
  const [expanded, setExpanded] = useState(props.expanded !== undefined ? props.expanded : true);

  function handleToggle() {
    if (!props.disabled) {
      setExpanded(!expanded);
    }
  }

  return (
    <CollapsiblePanelWrapper data-testid="collapsible-panel" expanded={expanded ? 1 : 0}>
      <CollapsiblePanelHeader onClick={handleToggle}>
        <Heading>{props.title}</Heading>
        <AnimatedToggleIcon expanded={expanded ? 1 : 0}></AnimatedToggleIcon>
      </CollapsiblePanelHeader>
      <CollapsiblePanelBody>{props.children}</CollapsiblePanelBody>
    </CollapsiblePanelWrapper>
  );
};

export default CollapsiblePanel;
